import React, { useState } from 'react';
import { BarChart3Icon, ChevronRightIcon, HomeIcon } from 'lucide-react';
import { BIFilters } from '../components/bi/BIFilters';
import { GlobalView } from '../components/bi/GlobalView';
import { BusinessUnitView } from '../components/bi/BusinessUnitView';
import { UserPerformanceView } from '../components/bi/UserPerformanceView';
type BILevel = 'global' | 'bu' | 'user';
export function BusinessIntelligencePageV2() {
  const [level, setLevel] = useState<BILevel>('global');
  const [filters, setFilters] = useState({
    bu: 'All',
    user: 'All',
    date: 'YTD',
    status: 'All',
    country: 'All',
    dealer: 'All'
  });
  const handleLevelChange = (newLevel: BILevel) => {
    setLevel(newLevel);
    // Reset filters based on level context
    if (newLevel === 'global') {
      setFilters(prev => ({
        ...prev,
        bu: 'All',
        user: 'All'
      }));
    } else if (newLevel === 'bu') {
      setFilters(prev => ({
        ...prev,
        bu: 'Aisco AMERICA',
        user: 'All'
      }));
    } else if (newLevel === 'user') {
      setFilters(prev => ({
        ...prev,
        bu: 'Aisco AMERICA',
        user: 'Alice Smith'
      }));
    }
  };
  return <div className="flex flex-col h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 overflow-hidden" data-id="element-7822">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-7823">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-7824"></div>
        <div className="absolute top-[40%] right-[10%] w-72 h-72 bg-purple-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-7825"></div>
        <div className="absolute bottom-[10%] left-[25%] w-80 h-80 bg-teal-600 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" data-id="element-7826"></div>
      </div>

      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950/80 via-indigo-950/60 to-purple-950/50 backdrop-blur-sm border-b border-white/10 px-6 relative z-10 flex-shrink-0 h-[72px] flex items-center" data-id="element-7827">
        <div className="flex items-center w-full" data-id="element-7828">
          {/* Breadcrumb — left */}
          <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-7829">
            <HomeIcon size={15} className="text-blue-300/60 hover:text-blue-200 cursor-pointer transition-colors flex-shrink-0" data-id="element-7830" />
            <ChevronRightIcon size={13} className="text-blue-300/40 flex-shrink-0" data-id="element-7831" />
            <span className="text-xs text-blue-300/60" data-id="element-7832">
              Business Intelligence
            </span>
            <ChevronRightIcon size={13} className="text-blue-300/40 flex-shrink-0" data-id="element-7833" />
            <span className="text-sm font-semibold text-white" data-id="element-7834">
              Quotes Analytics
            </span>
          </div>

          {/* Level Selector (Segmented Control) — centered */}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex bg-black/20 p-1 rounded-lg border border-white/10 flex-row items-center justify-center" data-id="element-7835">
            <button onClick={() => handleLevelChange('global')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all ${level === 'global' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/20' : 'text-blue-300 hover:text-white hover:bg-white/5'}`} data-id="element-7836">
              Global
            </button>
            <button onClick={() => handleLevelChange('bu')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all ${level === 'bu' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/20' : 'text-blue-300 hover:text-white hover:bg-white/5'}`} data-id="element-7837">
              Business Unit
            </button>
            <button onClick={() => handleLevelChange('user')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all ${level === 'user' ? 'bg-blue-600 text-white shadow-lg shadow-blue-900/20' : 'text-blue-300 hover:text-white hover:bg-white/5'}`} data-id="element-7838">
              User Performance
            </button>
          </div>
        </div>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto p-6 relative z-10 no-scrollbar" data-id="element-7839">
        <div className="max-w-7xl mx-auto" data-id="element-7840">
          {level === 'global' && <GlobalView data-id="element-7841" />}
          {level === 'bu' && <BusinessUnitView buName={filters.bu} onBuChange={bu => setFilters(prev => ({
          ...prev,
          bu
        }))} data-id="element-7842" />}
          {level === 'user' && <UserPerformanceView data-id="element-7843" />}
        </div>
      </div>
    </div>;
}